export default __webpack_public_path__ + "static/media/projector.9f5d3f83.png";